import type { PointWithdrawalType } from "@roman/shared/types/PointWithdrawal";
import { GiftTickets } from "./GiftTickets";
import { PointBalance } from "./PointBalance";

type Props = {
  onClickCard: (cardId: PointWithdrawalType) => void;
  points: number;
};

export const MyGiftPoints = ({ onClickCard, points }: Props) => {
  return (
    <div className="bg-white min-w-full min-h-screen">
      <div className="p-[18px] grid gap-10">
        <PointBalance points={points} />
        <GiftTickets onClickCard={onClickCard} />
      </div>
    </div>
  );
};
